import React from 'react';

const Logo = props => <img className="mainLogo" src={props.logo} alt="" />;

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js